export default __webpack_public_path__ + "static/SSSpyView_screenshot-5-746e9ec53aedcdce50d700b90c69bbc6.jpg";